<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                        dark
                        v-on="on"
                        class="navbar-toggler-profile"
                >
                  {{ $t("Профиль") }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <v-simple-table v-if="items.length">
                <thead>
                  <tr>
                    <th v-for="(field, id) in tableFields" :key="id">
                      <a>
                        <i class="pro-icon-arrow-bottom1"></i>
                        {{ field }}
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="{ item, commentNpa } in items" :key="item.id">
                    <td>
                      {{ item.text }}
                    </td>
                    <td>
                      {{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}
                    </td>
                    <td>
                      {{ commentNpa.view.transName }}
                    </td>
                    <td>
                      <router-link
                        :title="commentNpa.transProjectGoal | strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: commentNpa.id }
                        })"
                      >
                        {{ commentNpa.transName }}
                      </router-link>
                    </td>
                    <td>
                      <span
                        v-for="category in commentNpa.category"
                        :key="category.id"
                      >
                        {{ category.transName }},
                      </span>
                    </td>
                    <td>{{ commentNpa.status.transName }}</td>
                    <td>
                      {{
                        new Date(commentNpa.discussion_period_date_to)
                          | dateFormat('DD.MM.YYYY')
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t("Общее количество Жалоб") }}: {{ itemsTotal }}</p>
              </div>

              <v-pagination
                v-if="pagesCount > 1"
                v-model="page"
                :length="pagesCount"
                :total-visible="7"
                @input="changePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Widget from '@/components/app/Widget'
import Npa from '@/model/npa'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Widget
  },
  data: () => ({
    breadcrumbs: [],
    tableFields: [],
    items: [],
    itemsTotal: 0,
    page: 1,
    pagesCount: 1
  }),
  watch: {
    '$route.query.page'(newPage) {
      this.fetchData(newPage)
    }
  },
  created() {
    const page = Number(this.$route.query.page)
    this.page = page && page > 0 ? page : 1
    this.fetchData(this.page)
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    async fetchData(page) {
      this.setLoading(true)
      try {
        const { items, paginationData: paginator } = await Npa.getComplaints(
          page
        )
        this.breadcrumbs = [
          { text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile' },
          { text: this.$i18n.t('Все жалобы'), disabled: true }
        ]
        this.tableFields = [
          this.$i18n.t('Жалобы'),
          this.$i18n.t('Дата'),
          this.$i18n.t('Вид проекта'),
          this.$i18n.t('Наименование'),
          this.$i18n.t('Категория'),
          this.$i18n.t('Статус'),
          this.$i18n.t('Дата окончания обсуждения')
        ]
        this.items = items
        this.pagesCount = paginator.pageCount
        this.itemsTotal = paginator.totalCount
      } catch (error) {
        await this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
        this.setLoading(false)
      }

      this.setLoading(false)
    },
    changePage(page) {
      this.$router.push({ query: { page } })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
